import algosdk from "algosdk";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useWallet } from "../context/WalletContext";
import { useTransaction } from "../context/TransactionContext";
import "../styles/roulette.css";
import "../styles/general.css";

interface RouletteProps {
 algodClient: algosdk.Algodv2;
   setMessage: (msg: string) => void;
   account: string;
   username: string;
   algoBalance: number;
   umqBalance: number;
   logout: () => void;
}

const Roulette: React.FC<RouletteProps> = ({ algodClient, setMessage }) => {
  const navigate = useNavigate();
  const { account } = useWallet();

  const appId = 748989297;
  const appAddress = "4LLFYDHB5XIB3Z7HDKSLUHVTDF42XORW66R2EAUY4PQ32TSE6FH6IQXP4I";
  const asaId = 748884896;
  const [spinning, setSpinning] = useState(false);
  const [rotation, setRotation] = useState(0);
  const [isOptedIn, setIsOptedIn] = useState(false);
  const { openTransactionModal } = useTransaction();
  const [isAdmin, setIsAdmin] = useState(false);
  const [globalState, setGlobalState] = useState<any>({});
  const [prizes] = useState<number[]>([0e9, 10e9, 50e9, 100e9, 200e9, 500e9, 1000e9]);

  const accountAddress = account?.addr || "";

  useEffect(() => {
    setIsAdmin(accountAddress === appAddress);
  }, [accountAddress]);

  useEffect(() => {
    const checkOptInStatus = async () => {
      try {
        const accountInfo = await algodClient.accountInformation(accountAddress).do();
        const optedApps = accountInfo["apps-local-state"];
        setIsOptedIn(optedApps.some((app: any) => app.id === appId));
      } catch (error) { /* empty */ }
    };
    if (accountAddress) checkOptInStatus();
  }, [accountAddress, algodClient]);

  const checkAndOptIn = async (): Promise<void> => {
  try {
    const info = await algodClient.accountApplicationInformation(accountAddress, appId).do();
    const alreadyOptedIn = !!info["app-local-state"];
    if (alreadyOptedIn) return;
  } catch (e: any) {
    if (e.response?.status !== 404) throw e;
  }

  const suggestedParams = await algodClient.getTransactionParams().do();
  const optInTxn = algosdk.makeApplicationOptInTxn(accountAddress, suggestedParams, appId);
  const signedOptInTxn = optInTxn.signTxn(account!.sk);
  await algodClient.sendRawTransaction(signedOptInTxn).do();

  await waitForConfirmation(algodClient, optInTxn.txID());
};

  const spinRoulette = async () => {
  if (spinning || !accountAddress) return;

  setSpinning(true);
  const randomSpin = 5000 + Math.floor(Math.random() * 360);
  setRotation(prev => prev + randomSpin);

  try {
    if (!account?.sk) throw new Error("Cuenta inválida o no cargada.");

    await checkAndOptIn();

    const suggestedParams = await algodClient.getTransactionParams().do();

    
    const randomClientNumber = Math.floor(Math.random() * 1000000000);

    const feeTxn = algosdk.makeAssetTransferTxnWithSuggestedParamsFromObject({
      from: accountAddress,
      to: appAddress,
      amount: 15e9,
      assetIndex: asaId,
      suggestedParams,
    });

    const payTxn = algosdk.makeAssetTransferTxnWithSuggestedParamsFromObject({
      from: accountAddress,
      to: appAddress,
      amount: 100e9,
      assetIndex: asaId,
      suggestedParams,
    });

    const appArgs = [
      new Uint8Array(Buffer.from("spin")),                    
      algosdk.encodeUint64(randomClientNumber),              
    ];

    const appCallTxn = algosdk.makeApplicationNoOpTxnFromObject({
      from: accountAddress,
      appIndex: appId,
      appArgs,
      foreignAssets: [asaId],
      suggestedParams,
    });

    const txns = [feeTxn, payTxn, appCallTxn];
    algosdk.assignGroupID(txns);
    const signedTxns = txns.map(txn => txn.signTxn(account.sk));
    const { txId } = await algodClient.sendRawTransaction(signedTxns).do();

    setMessage(`Aprobado TxID: ${txId}`);
    await waitForConfirmation(algodClient, txId);

    const updatedState = await getAppGlobalState(appId);
    setGlobalState(updatedState);

    const lastPrize = updatedState["last_spin_result"]
      ? Number(updatedState["last_spin_result"]) / 1e9
      : 0;

    setTimeout(() => {
      if (lastPrize === 0) {
        setMessage(`Ganaste premio especial. Contacta a un asesor`);
      } else {
        setMessage(`⭐¡Ganaste ${lastPrize}⭐ UMQ! TxID: ${txId}`);
      }
    }, 200);
  } catch (error: any) {
    console.error("❌ Error en spinRoulette:", error);
    setMessage(`❌ Error al girar la ruleta: ${error?.message || "desconocido"}`);
  } finally {
    setTimeout(() => setSpinning(false), 3000);
  }
};


  const waitForConfirmation = async (client: algosdk.Algodv2, txId: string) => {
    const status = await client.status().do();
    let lastRound = status["last-round"];
    // eslint-disable-next-line no-constant-condition
    while (true) {
      const pending = await client.pendingTransactionInformation(txId).do();
      if (pending["confirmed-round"] && pending["confirmed-round"] > 0) return pending;
      lastRound++;
      await client.statusAfterBlock(lastRound).do();
    }
  };
  const handleOptIn = async () => {
  try {
    if (!account?.sk) throw new Error("Cuenta inválida o no cargada.");

    const suggestedParams = await algodClient.getTransactionParams().do();
    const optInTxn = algosdk.makeApplicationOptInTxn(accountAddress, suggestedParams, appId);
    const signedOptInTxn = optInTxn.signTxn(account.sk);
    await algodClient.sendRawTransaction(signedOptInTxn).do();

    await waitForConfirmation(algodClient, optInTxn.txID());
    setIsOptedIn(true);
    setMessage("✅ Opt-In exitoso.");
  } catch (error: any) {
    console.error("❌ Error al hacer Opt-In:", error);
    setMessage(`Error en Opt-In: ${error.message}`);
  }
};

  const getAppGlobalState = async (appId: number) => {
    const appInfo = await algodClient.getApplicationByID(appId).do();
    const globalState = appInfo.params["global-state"];
    return globalState.reduce((acc: any, entry: { key: string; value: { uint?: any; bytes?: any } }) => {
      const key = Buffer.from(entry.key, "base64").toString();
      acc[key] = entry.value.uint ?? entry.value.bytes;
      return acc;
    }, {});
  };

  useEffect(() => {
    const fetchGlobalState = async () => {
      try {
        const updatedState = await getAppGlobalState(appId);
        setGlobalState(updatedState);
      } catch (error) {
        setMessage("Error al consultar el estado de la ruleta.");
      }
    };
    fetchGlobalState();
  }, [account]);

  const handleSpin = () => {
  openTransactionModal({
    recipient: appAddress,
    amount: 100,
    asset: { name: "UMQ", id: 742691023, decimals: 9 },
    onConfirm: () => {
      spinRoulette();
    },
  });
};


  return (
    <div className="modal-container">
      <div className="roulette-container tribal-bg">
        <h1>Ruleta del Guerrero Holkan</h1>
        <div className="roulette-wrapper">
          <div
            className="roulette"
            style={{ transform: `rotate(${rotation}deg)`, transition: spinning ? "transform 5s ease-out" : "none" }}>
            {prizes.map((prize, index) => {
  const segmentAngle = 360 / prizes.length;
  const lastPrize = Number(globalState["last_spin_result"]) || 0;
  const prizeIndex = prizes.findIndex(p => Math.abs(p - lastPrize) < 1e9);
  const isWinningPrize = index === prizeIndex;

  return (
    <div
  key={index}
  className={`prize ${isWinningPrize ? "highlight" : ""}`}
  style={{
    transform: `rotate(${segmentAngle * index}deg) translateX(130%) translateY(-80%) rotate(-${segmentAngle * index}deg)`
  }}
>
  {prize !== 0 && <span>{prize / 1e9}</span>}
  <img
    src={
      prize === 0
        ? "/images/icon-192.png"
        : "/images/umq.avif"
    }
    alt={prize === 0 ? "Sin premio" : "UMQ"}
    style={{
      width: "36px",
      height: "36px",
      borderRadius: "50%", 
      backgroundColor: "#fff", 
      padding: "1px"
    }}
  />
</div>
  );
})}
          </div>
        </div>
        <button className="button-primary" onClick={handleSpin} disabled={false}>
          {spinning ? "Girando..." : "Jugar"}
        </button>

        {isAdmin && (
          <button className="button-primary" onClick={() => setMessage("Función de administrador aún no implementada")}>Admin</button>
        )}
        {!isOptedIn && (
  <button  disabled={false} onClick={handleOptIn} className="button-secondary">
    Activar Ruleta
  </button>
)}

        <button className="button-exit" onClick={() => navigate("/home")}>Volver</button>
        <div className="stats-and-missions">
          <div className="roulette-stats">
            <h4>Total Participantes: {globalState["total_participants"] != null ? Number(globalState["total_participants"]).toFixed(0) : "Cargando..."}</h4>
            <h4>Último Resultado: {globalState["last_spin_result"] != null ? (Number(globalState["last_spin_result"]) / 1e9) : "Cargando..."} UMQ</h4>
            <h4>Premios Distribuidos: {globalState["prizes_distributed"] != null ? (Number(globalState["prizes_distributed"]) / 1e9).toFixed(0) : "Cargando..."} UMQ</h4>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Roulette;
